import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

const badge = cva(
  'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      tone: {
        neutral: 'border border-border-translucent bg-surface-translucent text-text-muted',
        accent: 'bg-accent-subtle text-accent border border-accent/20',
        info: 'bg-info-bg text-info-fg border border-info-border',
        success: 'bg-success-bg text-success-fg border border-success-border',
        warning: 'bg-warning-bg text-warning-fg border border-warning-border',
        danger: 'bg-danger-bg text-danger-fg border border-danger-border',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps extends VariantProps<typeof badge> {
  className?: string;
  children: ReactNode;
}

/**
 * A status or category label.
 *
 * Colour is never the only carrier — a badge always has text. The tone is
 * reinforcement for people who perceive it, not the information itself.
 */
export function Badge({ tone, className, children }: BadgeProps) {
  return <span className={cn(badge({ tone }), className)}>{children}</span>;
}
